import gql from 'graphql-tag';

export const allLocationsGQL = gql`
  query($instId: String!) {
    institutions(instID: $instId) {
      locations {
        name
        loc_id
        experience_type
      }
    }
  }
`;
